<template>
    <vs-switch id="ads-table-switch-button" @click="updateStatus()" :value="isSelected"></vs-switch>
</template>

<script>
export default {
  data () {
    return {
      isSelected: false
    }
  },
  beforeMount () {
    this.isSelected = this.params.data.activation_status === 1
  },
  methods: {
    async updateStatus () {
      const ad = this.params.data

      const response = await window.axios.post(`/campaigns/${ad.campaignId}/update-ad-activation-status`, {
        status: ad.activation_status === 1 ? 'Paused' : 'Active',
        ad_id: ad.id,
        _method: 'PATCH'
      })

      if (response) {

        this.params.node.setData({
          ...this.params.node.data,
          activation_status: response.data.payload.activation_status,
          aggregated_status: response.data.payload.aggregated_status
        })

        this.$nextTick(() => {
          this.params.api.refreshCells({
            rowNodes: [this.params.node],
            force: true
          })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.vs-switch-primary {
  background: red !important;
}

.vs-switch-active {
  background: rgba(var(--vs-primary), 1) !important;
}

</style>
